import { MessageCircle, Phone, ArrowUp } from "lucide-react";
import { COMPANY } from "./data";

export default function Floating({ onQuote }) {
  return (
    <div data-testid="quick-contact-speeddial" className="fixed bottom-5 right-5 z-[60] flex flex-col items-end gap-2.5">
      <button
        data-testid="float-quote-button"
        onClick={onQuote}
        aria-label="Request a quote"
        className="w-11 h-11 bg-slate-900 hover:bg-blue-700 text-white flex items-center justify-center rounded-full shadow-md transition-colors"
      >
        <ArrowUp className="w-5 h-5" />
      </button>
      <a
        data-testid="float-call-button"
        href={`tel:${COMPANY.phoneRaw}`}
        aria-label="Call Laneeka International"
        className="w-11 h-11 bg-white border border-slate-300 text-slate-800 hover:border-blue-700 hover:text-blue-700 flex items-center justify-center rounded-full shadow-md transition-colors"
      >
        <Phone className="w-5 h-5" />
      </a>
      <a
        data-testid="float-whatsapp-button"
        href={COMPANY.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="w-12 h-12 bg-[#25D366] hover:bg-[#1fb857] text-white flex items-center justify-center rounded-full shadow-md transition-colors"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
    </div>
  );
}
